
<template>
  <div class="report-container">
    <iframe
      :src="reportUrl"
      frameborder="0"
      class="report-iframe"
    ></iframe>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TokenService from '../../../../helpers/token';

export default {
  name: 'ProductV2GroupReport',
  data() {
    return {
      staticToken: TokenService.getRsa256Token(),
      baseUrl: process.env.VUE_APP_REPORT_BASE_URL,
    };
  },
  computed: {
    ...mapState({
      selectedModule: (state) => state.module || {},
    }),
    reportUrl() {
      const params = new URLSearchParams({
        token: this.staticToken,
      });

      if (this.selectedModule.typeId) {
        params.append('typeId', this.selectedModule.typeId);
      }

      if(this.selectedModule.schoolLevelId){
        params.append('schoolLevelId', this.selectedModule.schoolLevelId);
      }

      return `${this.baseUrl}/reports/product-report?${params.toString()}`;
    },
  },
};
</script>

<style scoped>
.report-container {
  width: 100%;
  height: calc(100vh - 60px); 
  padding: 0;
  margin: 0;
}

.report-iframe {
  width: 100%;
  height: 100%;
  border: none; 
}
</style>
